import isObject from 'lodash/isObject';
import { ALLOWED_HOSTS } from '../../e2e/constants';

export const isRunningContextCypress = context => {
  return (
    context &&
    isObject(context.Cypress) &&
    context.location &&
    ALLOWED_HOSTS.indexOf(context.location.hostname) !== -1
  );
};

export const cyElementSelector = id => `[data-cy="${id}"]`;

export const cySelectableSelector = selected => `[data-cy-selected="${!!selected}"`;

export const cyCheckboxSelector = () => `input[type="checkbox"]`;

export const cyRadioSelector = value => `input[type="radio"][value="${value}"]`;

export const generateCyElemId = (id, context) =>
  id && isRunningContextCypress(context) ? { 'data-cy': id } : {};

export const generateCyElemIdWithValue = (id, value, context) =>
  // we pass value as string so undefined values are preserved
  isRunningContextCypress(context) ? { 'data-cy': id, 'data-cy-value': `${value}` } : {};

export const cyElementWithValueSelector = (id, value) =>
  `[data-cy="${id}"][data-cy-value="${value}"]`;

export const generateCySelectable = (selected, context) =>
  isRunningContextCypress(context) ? { 'data-cy-selected': selected } : {};

export const addCyPrefixToID = (prefix, elementID) => `${prefix}_${elementID}`;

export const addCyPrefixToIDs = (prefix, elementIDs) => {
  Object.keys(elementIDs).forEach(id => (elementIDs[id] = addCyPrefixToID(prefix, elementIDs[id])));
  return elementIDs;
};
